export enum AUTH_TYPE {
  SIGN_UP = 'signup',
  SIGN_IN = 'signin'
}
